export const representativeDeleteCopy = {
  deleteConfirm: (firstName: string, lastName: string) =>
    `This permanently removes ${firstName} ${lastName} and all of their representative data, including notification preferences created at signup. This action cannot be undone.`,
  deleteSuccess: 'The representative has been permanently deleted.',
  deleteError:
    'We could not delete this representative. Try again, or contact MeetingMD support if it keeps happening.',
  blockedIntro: (firstName: string, lastName: string) =>
    `${firstName} ${lastName} cannot be permanently deleted right now:`,
  blockedReasonPrefix: 'This representative cannot be deleted because',
};

export const formatRepresentativeDeleteBlockers = (reasons: string[]) => {
  if (reasons.length === 0) {
    return '';
  }

  if (reasons.length === 1) {
    return reasons[0];
  }

  if (reasons.length === 2) {
    return `${reasons[0]} and ${reasons[1]}`;
  }

  return `${reasons.slice(0, -1).join(', ')}, and ${reasons[reasons.length - 1]}`;
};

export type RepresentativeDeleteTarget = {
  key: string;
  firstName: string;
  lastName: string;
  canDelete?: boolean;
  cannotDeleteReasons?: string[];
};
